import React from 'react'

import { SmallText, Title } from '../../../../components/presentation/Text'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Separator from '../../../../components/helpers/Separator'
import { usePlace } from '../../_load/PlaceLoader'
import { useQrcode } from '../../_load/QrcodeLoader'

const PlacePageHeader = () => {
  const place = usePlace()
  const { name } = useQrcode()?.data || {}

  return (
    <FlexGrid direction="column" justify="flex-start" gutter={0.5}>
      <Separator weight={4} />
      <Title align="center" size="h2">
        'Olá, boas-vindas!'
      </Title>
      <SmallText align="center" maxWidth={22}>
        {'Você está acessando: '}
        <b>{name || place?.name}</b>.<br />
        {'Em que podemos lhe ajudar?'}
      </SmallText>
      <Separator weight={6} />
    </FlexGrid>
  )
}

export default PlacePageHeader
